import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const guides = [
  { title: 'CSSBuy Spreadsheet Complete Guide', href: '/cssbuy-spreadsheet/', desc: 'Everything you need to know about using CSSBuy Spreadsheet effectively.' },
  { title: 'CSSBuy Review', href: '/cssbuy-review/', desc: 'Independent review of CSSBuy features, pros, cons, and user experience.' },
  { title: 'CSSBuy Shipping Cost Guide', href: '/shipping/', desc: 'Understand shipping costs, methods, and how to reduce expenses.' },
  { title: 'CSSBuy Safety Guide', href: '/safety/', desc: 'Learn how to protect yourself when using buying agents and online marketplaces.' },
];

export default function GuidesPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <section className="pt-20 md:pt-24 pb-8 md:pb-12 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-2 mb-4">
              <a href="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1">
                <i className="ri-home-line w-3 h-3 flex items-center justify-center" /> Home
              </a>
              <span className="text-foreground-300">/</span>
              <span className="text-xs text-primary-600 font-medium">Guides</span>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
              CSSBuy <span className="text-primary-500">Guides</span> & Resources
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
              Practical guides to help you use CSSBuy Spreadsheet, understand shipping, compare options, and buy with confidence.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              {guides.map((guide) => (
                <a
                  key={guide.href}
                  href={guide.href}
                  className="group block bg-white rounded-xl p-6 border border-background-200 hover:border-primary-300 hover:shadow-md transition-all"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0 group-hover:bg-primary-100 transition-colors">
                      <i className="ri-book-open-line w-5 h-5 flex items-center justify-center text-primary-500 text-lg" />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-semibold text-sm text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                        {guide.title}
                      </h3>
                      <p className="text-xs text-foreground-500 leading-relaxed mb-3">{guide.desc}</p>
                      <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                        Read Guide <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center" />
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>

            <div className="mt-12 p-6 bg-accent-50 border border-accent-200 rounded-xl">
              <h3 className="font-heading text-base font-bold text-accent-900 mb-2">More Guides Coming Soon</h3>
              <p className="text-sm text-accent-700 leading-relaxed">
                We are continuously expanding our guide library with more topics including QC processes, warehouse management, coupon strategies, and buying from specific platforms. Bookmark this page and check back regularly for updates.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}